module.exports = __webpack_public_path__ + "static/media/ik.17c4acb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/ik.png
// module id = 429
// module chunks = 0